import { createBrowserHistory } from 'history';
import * as routes from '~/config/routes';

const history = createBrowserHistory();

function findRoute(location) {
  return (
    Object.values(routes).find(route => route.match(location.pathname)) ||
    routes.peoples
  );
}

function findRouteMenu(location) {
  return (
    Object.values(routes).find(route => route.matchMenu(location.route, location.pathname)) ||
    routes.peoples
  );
}

// Carrega a instancia Route e seta no location para ser usado
// internamente nos componentes
history.listen(location => {
  location.route = findRoute(location);
  location.routeMenu = findRouteMenu(location);

  history.location.route.history = history;
  history.location.routeMenu.history = history;
});

history.location.route = findRoute(history.location);
history.location.routeMenu = findRouteMenu(history.location);

history.location.route.history = history;
history.location.routeMenu.history = history;

export default history;
